module.exports = __webpack_public_path__ + "src/assets/img/play.2e95ce01.svg";